import styled from 'styled-components';

const ButtonIcon = styled.i`
  margin-right: 10%;
`;

export default ButtonIcon;
